const preferredNetworks = [
  {
    countryName: 'Australia',
    countryCode: 'AUS',
    networks: ['Vodafone', 'Optus'],
    cities: [
      'Sydney',
      'Melbourne',
      'Brisbane',
      'Perth',
      'Adelaide',
      'Gold Coast',
      'Sunshine Coast',
      'Cairns',
      'Darwin',
      'Hobart',
      'Canberra',
      'Newcastle',
      'Wollongong',
      'Geelong',
      'Townsville',
      'Ballarat',
      'Bendigo',
      'Launceston',
      'Albury',
      'Port Macquarie',
      'Coffs Harbour',
      'Mackay',
      'Rockhampton',
      'Bunbury',
      'Geraldton',
      'Port Hedland',
      'Broome',
      'Alice Springs',
      'Kalgoorlie',
      'Karratha',
      'Mount Gambier',
      'Mildura',
      'Dubbo',
      'Wagga Wagga'
    ],
    countryFlag: 'https://flagcdn.com/au.svg'
  },
  {
    countryName: 'Austria',
    countryCode: 'AUT',
    networks: ['Drei', '3'],
    cities: [
      'Vienna',
      'Salzburg',
      'Innsbruck',
      'Graz',
      'Linz',
      'Klagenfurt',
      'Baden bei Wien',
      'Eisenstadt',
      'Villach',
      'St. Pölten',
      'Wels',
      'Feldkirch',
      'Bregenz',
      'Dornbirn',
      'Wiener Neustadt',
      'Krems an der Donau',
      'Leoben',
      'Amstetten',
      'Kufstein',
      'Traun',
      'Schwechat',
      'Hallein',
      'Telfs',
      'Bruck an der Mur',
      'Saalfelden',
      'Tulln',
      'Stockerau'
    ],
    countryFlag: 'https://flagcdn.com/at.svg'
  },
  {
    countryName: 'Bangladesh',
    countryCode: 'BGD',
    networks: ['GrameenPhone'],
    cities: [
      'Dhaka',
      'Chittagong',
      'Khulna',
      'Rajshahi',
      'Sylhet',
      'Barisal',
      'Comilla',
      'Narayanganj',
      'Mymensingh',
      'Jessore',
      'Bogra',
      'Rangpur',
      'Dinajpur',
      'Pabna',
      "Cox's Bazar",
      'Nawabganj',
      'Tangail',
      'Faridpur',
      'Jamalpur',
      'Kushtia',
      'Brahmanbaria',
      'Kishoreganj',
      'Saidpur',
      'Tongi',
      'Sirajganj',
      'Joypurhat',
      'Gazipur',
      'Natore',
      'Manikganj'
    ],
    countryFlag: 'https://flagcdn.com/bd.svg'
  },
  {
    countryName: 'Belgium',
    countryCode: 'BEL',
    networks: ['BASE', 'Orange', 'Proximus PLC'],
    cities: [
      'Brussels',
      'Antwerp',
      'Ghent',
      'Charleroi',
      'Liege',
      'Bruges',
      'Namur',
      'Leuven',
      'Mons',
      'Mechelen',
      'Aalst',
      'La Louviere',
      'Kortrijk',
      'Hasselt',
      'Ostend',
      'Sint-Niklaas',
      'Tournai',
      'Genk',
      'Seraing',
      'Roeselare',
      'Verviers',
      'Mouscron',
      'Beveren',
      'Dendermonde',
      'Bilzen',
      'Lokeren'
    ],
    countryFlag: 'https://flagcdn.com/be.svg'
  },
  {
    countryName: 'Bulgaria',
    countryCode: 'BGR',
    networks: ['Telenor', 'A1'],
    cities: [
      'Sofia',
      'Plovdiv',
      'Varna',
      'Burgas',
      'Ruse',
      'Stara Zagora',
      'Pleven',
      'Sliven',
      'Dobrich',
      'Shumen',
      'Pernik',
      'Yambol',
      'Haskovo',
      'Blagoevgrad',
      'Veliko Tarnovo',
      'Gabrovo',
      'Asenovgrad',
      'Vratsa',
      'Kardzhali',
      'Kyustendil',
      'Montana',
      'Lovech',
      'Targovishte',
      'Silistra',
      'Vidin'
    ],
    countryFlag: 'https://flagcdn.com/bg.svg'
  },
  {
    countryName: 'China',
    countryCode: 'CHN',
    networks: ['China Unicom'],
    cities: [
      'Beijing',
      'Shanghai',
      'Guangzhou',
      'Shenzhen',
      'Chengdu',
      'Chongqing',
      'Tianjin',
      'Hangzhou',
      'Nanjing',
      'Wuhan',
      "Xi'an",
      'Suzhou',
      'Qingdao',
      'Shenyang',
      'Dalian',
      'Xiamen',
      'Kunming',
      'Harbin',
      'Ningbo',
      'Zhengzhou',
      'Wuxi',
      'Changsha',
      'Fuzhou',
      'Taiyuan',
      'Nanchang',
      'Changchun',
      'Hefei',
      'Lanzhou',
      'Guiyang',
      'Nanning',
      'Ürümqi',
      'Haikou',
      'Lhasa'
    ],
    countryFlag: 'https://flagcdn.com/cn.svg'
  },
  {
    countryName: 'Croatia',
    countryCode: 'HRV',
    networks: ['Telemach', 'A1'],
    cities: [
      'Zagreb',
      'Split',
      'Rijeka',
      'Osijek',
      'Zadar',
      'Pula',
      'Šibenik',
      'Dubrovnik',
      'Varaždin',
      'Karlovac',
      'Sisak',
      'Vukovar',
      'Bjelovar',
      'Koprivnica',
      'Čakovec',
      'Vinkovci',
      'Požega',
      'Krapina',
      'Knin',
      'Metković',
      'Sinj',
      'Imotski',
      'Omiš',
      'Makarska',
      'Trogir',
      'Krk',
      'Rovinj',
      'Poreč',
      'Rab',
      'Pag',
      'Nin'
    ],
    countryFlag: 'https://flagcdn.com/hr.svg'
  },
  {
    countryName: 'Cyprus',
    countryCode: 'CYP',
    networks: ['Cyta', 'Epic'],
    cities: [
      'Nicosia',
      'Limassol',
      'Larnaca',
      'Paphos',
      'Famagusta',
      'Kyrenia',
      'Protaras',
      'Ayia Napa',
      'Paralimni'
    ],
    countryFlag: 'https://flagcdn.com/cy.svg'
  },
  {
    countryName: 'Czech Republic',
    countryCode: 'CZE',
    networks: ['O2', 'Vodafone'],
    cities: [
      'Prague',
      'Brno',
      'Ostrava',
      'Plzeň',
      'Liberec',
      'Olomouc',
      'Hradec Králové',
      'České Budějovice',
      'Pardubice',
      'Ústí nad Labem',
      'Zlín',
      'Karlovy Vary',
      'Jihlava',
      'Teplice',
      'Děčín',
      'Chomutov',
      'Prostějov',
      'Kladno',
      'Most',
      'Havířov',
      'Mladá Boleslav',
      'Kroměříž',
      'Český Těšín',
      'Litvínov',
      'Krnov',
      'Jablonec nad Nisou',
      'Třebíč'
    ],
    countryFlag: 'https://flagcdn.com/cz.svg'
  },
  {
    countryName: 'Denmark',
    countryCode: 'DNK',
    networks: ['Telenor', '3', 'TDC'],
    cities: [
      'Copenhagen',
      'Aarhus',
      'Odense',
      'Aalborg',
      'Esbjerg',
      'Randers',
      'Kolding',
      'Horsens',
      'Vejle',
      'Roskilde',
      'Helsingør',
      'Hillerød',
      'Holstebro',
      'Næstved',
      'Fredericia',
      'Frederikshavn',
      'Ringsted',
      'Silkeborg',
      'Sønderborg',
      'Viborg',
      'Herning',
      'Køge',
      'Slagelse',
      'Tårnby',
      'Albertslund',
      'Frederiksberg',
      'Gentofte',
      'Gladsaxe',
      'Glostrup',
      'Hvidovre',
      'Ishøj',
      'Lyngby-Taarbæk',
      'Rødovre',
      'Vallensbæk',
      'Hjørring'
    ],
    countryFlag: 'https://flagcdn.com/dk.svg'
  },
  {
    countryName: 'Estonia',
    countryCode: 'EST',
    networks: ['Tele2', 'Elisa'],
    cities: [
      'Tallinn',
      'Tartu',
      'Narva',
      'Pärnu',
      'Kohtla-Järve',
      'Viljandi',
      'Rakvere',
      'Maardu',
      'Sillamäe',
      'Valga',
      'Võru',
      'Kiviõli',
      'Tapa',
      'Jõhvi',
      'Haapsalu',
      'Keila',
      'Rapla',
      'Põlva',
      'Saue',
      'Paldiski'
    ],
    countryFlag: 'https://flagcdn.com/ee.svg'
  },
  {
    countryName: 'Finland',
    countryCode: 'FIN',
    networks: ['DNA', 'Elisa'],
    cities: [
      'Helsinki',
      'Espoo',
      'Tampere',
      'Vantaa',
      'Turku',
      'Oulu',
      'Jyväskylä',
      'Lahti',
      'Kuopio',
      'Pori',
      'Kouvola',
      'Joensuu',
      'Lappeenranta',
      'Vaasa',
      'Hämeenlinna',
      'Seinäjoki',
      'Mikkeli',
      'Kokkola',
      'Hyvinkää',
      'Nurmijärvi',
      'Rauma',
      'Rovaniemi',
      'Salo',
      'Kotka',
      'Kajaani',
      'Kerava',
      'Savonlinna',
      'Kemi',
      'Iisalmi',
      'Lohja',
      'Forssa',
      'Imatra',
      'Naantali',
      'Orimattila',
      'Uusikaupunki',
      'Karkkila',
      'Pieksämäki',
      'Tornio',
      'Heinola',
      'Riihimäki',
      'Siuntio',
      'Hanko',
      'Laitila'
    ],
    countryFlag: 'https://flagcdn.com/fi.svg'
  },
  {
    countryName: 'France',
    countryCode: 'FRA',
    networks: ['SFR', 'Orange', 'Bouygues'],
    cities: [
      'Paris',
      'Marseille',
      'Lyon',
      'Toulouse',
      'Nice',
      'Nantes',
      'Strasbourg',
      'Montpellier',
      'Bordeaux',
      'Lille',
      'Rennes',
      'Reims',
      'Le Havre',
      'Saint-Étienne',
      'Toulon',
      'Grenoble',
      'Dijon',
      'Angers',
      'Nîmes',
      'Villeurbanne',
      'Saint-Denis',
      'Le Mans',
      'Aix-en-Provence',
      'Clermont-Ferrand',
      'Brest',
      'Tours',
      'Limoges',
      'Amiens',
      'Annecy',
      'Perpignan',
      'Boulogne-Billancourt',
      'Metz',
      'Besançon',
      'Saint-Paul',
      'Caen',
      'Mulhouse',
      'Rouen',
      'Nancy',
      'Argenteuil',
      'Montreuil',
      'Saint-Denis',
      'Roubaix',
      'Tourcoing',
      'Fort-de-France',
      'Vitry-sur-Seine',
      'Avignon',
      'Créteil',
      'Poitiers',
      'Dunkerque',
      'Asnières-sur-Seine',
      'Courbevoie'
    ],
    countryFlag: 'https://flagcdn.com/fr.svg'
  },
  {
    countryName: 'Germany',
    countryCode: 'DEU',
    networks: ['O2', 'Vodafone'],
    cities: [
      'Berlin',
      'Hamburg',
      'Munich',
      'Cologne',
      'Frankfurt',
      'Stuttgart',
      'Düsseldorf',
      'Dortmund',
      'Essen',
      'Leipzig',
      'Bremen',
      'Dresden',
      'Hanover',
      'Nuremberg',
      'Duisburg',
      'Bochum',
      'Wuppertal',
      'Bielefeld',
      'Bonn',
      'Münster',
      'Karlsruhe',
      'Mannheim',
      'Augsburg',
      'Wiesbaden',
      'Gelsenkirchen',
      'Mönchengladbach',
      'Braunschweig',
      'Chemnitz',
      'Kiel',
      'Aachen',
      'Halle',
      'Magdeburg',
      'Freiburg',
      'Krefeld',
      'Lübeck',
      'Oberhausen',
      'Erfurt',
      'Mainz',
      'Rostock',
      'Kassel',
      'Hagen',
      'Saarbrücken',
      'Hamm',
      'Potsdam',
      'Leverkusen',
      'Oldenburg',
      'Solingen',
      'Herne',
      'Neuss',
      'Paderborn',
      'Heidelberg',
      'Ingolstadt',
      'Bremerhaven',
      'Offenbach',
      'Cottbus',
      'Göttingen',
      'Wolfsburg',
      'Bottrop',
      'Trier',
      'Recklinghausen',
      'Reutlingen',
      'Fürth',
      'Koblenz',
      'Moers',
      'Siegen',
      'Bergisch Gladbach',
      'Jena',
      'Gera',
      'Gießen',
      'Neumünster',
      'Aschaffenburg',
      'Weimar',
      'Gütersloh',
      'Herten',
      'Ibbenbüren',
      'Herford',
      'Schwäbisch Gmünd',
      'Sankt Augustin',
      'Eisenach',
      'Buxtehude',
      'Alsdorf',
      'Haltern am See',
      'Langenfeld',
      'Lohmar',
      'Lohne',
      'Rietberg',
      'Rottweil',
      'Seevetal',
      'Stutensee',
      'Waltrop'
    ],
    countryFlag: 'https://flagcdn.com/de.svg'
  },
  {
    countryName: 'Greece',
    countryCode: 'GRC',
    networks: ['Cosmote', 'Vodafone'],
    cities: [
      'Athens',
      'Thessaloniki',
      'Patras',
      'Heraklion',
      'Larissa',
      'Volos',
      'Ioannina',
      'Chania',
      'Chalcis',
      'Kavala',
      'Rhodes',
      'Serres',
      'Drama',
      'Alexandroupoli',
      'Katerini',
      'Komotini',
      'Kalamata',
      'Tripoli',
      'Corinth',
      'Pyrgos',
      'Livadeia',
      'Chios',
      'Kos',
      'Florina',
      'Kilkis',
      'Veria',
      'Sparta',
      'Mytilene',
      'Amaliada',
      'Xanthi',
      'Argos',
      'Megara',
      'Naousa',
      'Arta',
      'Edessa',
      'Grevena',
      'Kastoria',
      'Karditsa',
      'Preveza',
      'Farsala',
      'Orestiada',
      'Didymoteicho',
      'Karpenisi',
      'Levadia',
      'Ierapetra',
      'Korinthos',
      'Lamia',
      'Messolonghi',
      'Metsovo',
      'Nafpaktos',
      'Nafplio',
      'Parga',
      'Pylos',
      'Rethymno',
      'Salamis',
      'Samos',
      'Trikala',
      'Veroia',
      'Zakynthos'
    ],
    countryFlag: 'https://flagcdn.com/gr.svg'
  },
  {
    countryName: 'Hong Kong',
    countryCode: 'HKG',
    networks: ['CSL'],
    cities: [
      'Hong Kong Island',
      'Kowloon',
      'Tsuen Wan',
      'Tuen Mun',
      'Sha Tin',
      'Tseung Kwan O',
      'Yuen Long',
      'Sai Kung',
      'Ma On Shan',
      'Causeway Bay',
      'Central',
      'Wan Chai',
      'Mong Kok',
      'Tsim Sha Tsui',
      'Cheung Chau',
      'Lamma Island',
      'Peng Chau',
      'Lantau Island'
    ],
    countryFlag: 'https://flagcdn.com/hk.svg'
  },
  {
    countryName: 'Hungary',
    countryCode: 'HUN',
    networks: ['Vodafone', 'Telenor'],
    cities: [
      'Budapest',
      'Debrecen',
      'Miskolc',
      'Szeged',
      'Pécs',
      'Győr',
      'Nyíregyháza',
      'Kecskemét',
      'Székesfehérvár',
      'Szombathely',
      'Sopron',
      'Veszprém',
      'Eger',
      'Zalaegerszeg',
      'Tatabánya',
      'Dunaújváros',
      'Ózd',
      'Salgótarján'
    ],
    countryFlag: 'https://flagcdn.com/hu.svg'
  },
  {
    countryName: 'Iceland',
    countryCode: 'ISL',
    networks: ['Vodafone'],
    cities: [
      'Reykjavik',
      'Kopavogur',
      'Hafnarfjordur',
      'Akureyri',
      'Keflavik',
      'Garðabær',
      'Mosfellsbaer',
      'Selfoss',
      'Seltjarnarnes',
      'Grindavik',
      'Hveragerði',
      'Vestmannaeyjar'
    ],
    countryFlag: 'https://flagcdn.com/is.svg'
  },
  {
    countryName: 'India',
    countryCode: 'IND',
    networks: ['Airtel', 'Vodafone Idea'],
    cities: [
      'Mumbai',
      'Delhi',
      'Bengaluru',
      'Hyderabad',
      'Chennai',
      'Kolkata',
      'Pune',
      'Ahmedabad',
      'Surat',
      'Jaipur',
      'Lucknow',
      'Kanpur',
      'Nagpur',
      'Visakhapatnam',
      'Bhopal',
      'Patna',
      'Ludhiana',
      'Agra',
      'Nashik',
      'Vadodara',
      'Varanasi',
      'Madurai',
      'Jamshedpur',
      'Noida',
      'Rajkot',
      'Amritsar',
      'Jabalpur',
      'Gwalior',
      'Vijayawada',
      'Jodhpur',
      'Raipur',
      'Kota',
      'Salem',
      'Bhubaneswar',
      'Gurgaon',
      'Chandigarh',
      'Guwahati',
      'Hubballi-Dharwad',
      'Tiruchirappalli',
      'Bareilly',
      'Moradabad',
      'Aligarh',
      'Srinagar',
      'Guntur',
      'Bhiwandi',
      'Saharanpur',
      'Gorakhpur',
      'Bikaner',
      'Shimla',
      'Warangal',
      'Muzaffarnagar',
      'Thrissur',
      'Kollam',
      'Kannur',
      'Kozhikode',
      'Puducherry',
      'Dibrugarh',
      'Silchar',
      'Dimapur'
    ],
    countryFlag: 'https://flagcdn.com/in.svg'
  },
  {
    countryName: 'Indonesia',
    countryCode: 'IDN',
    networks: ['Telkomsel'],
    cities: [
      'Jakarta',
      'Surabaya',
      'Medan',
      'Bandung',
      'Bekasi',
      'Tangerang',
      'Depok',
      'Semarang',
      'Palembang',
      'Makassar',
      'Tangerang Selatan',
      'Bogor',
      'Padang',
      'Pekanbaru',
      'Denpasar',
      'Batam',
      'Bandar Lampung',
      'Malang',
      'Samarinda',
      'Serang',
      'Cimahi',
      'Pontianak',
      'Balikpapan',
      'Jambi',
      'Sukabumi',
      'Yogyakarta',
      'Kupang',
      'Palu',
      'Kediri',
      'Ambon',
      'Jayapura',
      'Bengkulu',
      'Madiun',
      'Manado',
      'Mataram',
      'Parepare',
      'Probolinggo',
      'Singkawang',
      'Pematangsiantar',
      'Padang Sidempuan',
      'Tanjung Pinang',
      'Lhokseumawe'
    ],
    countryFlag: 'https://flagcdn.com/id.svg'
  },
  {
    countryName: 'Ireland',
    countryCode: 'IRL',
    networks: ['Vodafone', 'Eir', '3'],
    cities: [
      'Dublin',
      'Cork',
      'Limerick',
      'Galway',
      'Waterford',
      'Drogheda',
      'Dundalk',
      'Swords',
      'Bray',
      'Navan',
      'Kilkenny',
      'Ennis',
      'Tralee',
      'Carlow',
      'Newbridge',
      'Naas',
      'Athlone',
      'Portlaoise',
      'Mullingar',
      'Wexford',
      'Balbriggan',
      'Greystones',
      'Clonmel',
      'Longford',
      'Nenagh',
      'Trim'
    ],
    countryFlag: 'https://flagcdn.com/ie.svg'
  },
  {
    countryName: 'Israel',
    countryCode: 'ISR',
    networks: ['Partner', 'Pelephone'],
    cities: [
      'Jerusalem',
      'Tel Aviv',
      'Haifa',
      'Ashdod',
      'Rishon LeZion',
      'Petah Tikva',
      'Beersheba',
      'Netanya',
      'Holon',
      'Bnei Brak',
      'Bat Yam',
      'Ramat Gan',
      'Rehovot',
      'Herzliya',
      'Kiryat Gat',
      'Kiryat Malakhi',
      'Acre',
      'Nazareth',
      'Tiberias',
      'Eilat'
    ],
    countryFlag: 'https://flagcdn.com/il.svg'
  },
  {
    countryName: 'Italy',
    countryCode: 'ITA',
    networks: ['WINDTRE', 'Vodafone', 'Wind'],
    cities: [
      'Rome',
      'Milan',
      'Naples',
      'Turin',
      'Palermo',
      'Genoa',
      'Bologna',
      'Florence',
      'Bari',
      'Catania',
      'Venice',
      'Verona',
      'Messina',
      'Padua',
      'Trieste',
      'Brescia',
      'Taranto',
      'Reggio Calabria',
      'Modena',
      'Cagliari',
      'Prato',
      'Livorno',
      'Foggia',
      'Ravenna',
      'Forlì'
    ],
    countryFlag: 'https://flagcdn.com/it.svg'
  },
  {
    countryName: 'Japan',
    countryCode: 'JPN',
    networks: ['SoftBank', 'KDDI'],
    cities: [
      'Tokyo',
      'Yokohama',
      'Osaka',
      'Nagoya',
      'Sapporo',
      'Kobe',
      'Kyoto',
      'Fukuoka',
      'Kawasaki',
      'Hiroshima',
      'Sendai',
      'Kitakyushu',
      'Chiba',
      'Saitama',
      'Sakai',
      'Niigata',
      'Hamamatsu',
      'Shizuoka',
      'Okayama',
      'Kumamoto',
      'Kurashiki',
      'Nagasaki',
      'Nara',
      'Matsuyama',
      'Akita'
    ],
    countryFlag: 'https://flagcdn.com/jp.svg'
  },
  {
    countryName: 'Liechtenstein',
    countryCode: 'LIE',
    networks: ['FL1', '7acht'],
    cities: [
      'Vaduz',
      'Schaan',
      'Triesen',
      'Triesenberg',
      'Eschen',
      'Mauren',
      'Ruggell',
      'Gamprin',
      'Balzers',
      'Planken'
    ],
    countryFlag: 'https://flagcdn.com/li.svg'
  },
  {
    countryName: 'Lithuania',
    countryCode: 'LTU',
    networks: ['Tele2', 'Bite'],
    cities: [
      'Vilnius',
      'Kaunas',
      'Klaipeda',
      'Šiauliai',
      'Panevėžys',
      'Alytus',
      'Marijampolė',
      'Mažeikiai',
      'Jonava',
      'Utena',
      'Kėdainiai',
      'Telšiai',
      'Visaginas',
      'Tauragė',
      'Ukmergė'
    ],
    countryFlag: 'https://flagcdn.com/lt.svg'
  },
  {
    countryName: 'Luxembourg',
    countryCode: 'LUX',
    networks: ['Orange'],
    cities: [
      'Luxembourg City',
      'Esch-sur-Alzette',
      'Differdange',
      'Dudelange',
      'Ettelbruck',
      'Diekirch',
      'Strassen',
      'Bertrange',
      'Belvaux',
      'Rumelange',
      'Mersch',
      'Schifflange',
      'Bissen',
      'Kopstal',
      'Bascharage',
      'Mamer',
      'Kayl',
      'Grevenmacher',
      'Wiltz',
      'Echternach'
    ],
    countryFlag: 'https://flagcdn.com/lu.svg'
  },
  {
    countryName: 'Macau',
    countryCode: 'MAC',
    networks: ['CTM'],
    cities: [
      'Macau Peninsula',
      'Taipa',
      'Cotai',
      'Coloane',
      'Seac Pai Van',
      'Barra',
      'Santo António',
      'São Lázaro',
      'Horta e Costa',
      'Nossa Senhora de Fátima',
      'Ká-Hó',
      'Ilha Verde',
      'Patane',
      'São Francisco Xavier',
      'Taipa Grande',
      'Taipa Pequena',
      'Coloane Village',
      'Cotai Strip'
    ],
    countryFlag: 'https://flagcdn.com/mo.svg'
  },
  {
    countryName: 'Malaysia',
    countryCode: 'MYS',
    networks: ['Celcom', 'Maxis'],
    cities: [
      'Kuala Lumpur',
      'George Town',
      'Johor Bahru',
      'Ipoh',
      'Kuching',
      'Kota Kinabalu',
      'Shah Alam',
      'Malacca City',
      'Alor Setar',
      'Seremban',
      'Miri',
      'Petaling Jaya',
      'Kuantan',
      'Subang Jaya',
      'Kota Bharu',
      'Bintulu',
      'Sungai Petani',
      'Taiping',
      'Sandakan',
      'Kuala Terengganu'
    ],
    countryFlag: 'https://flagcdn.com/my.svg'
  },
  {
    countryName: 'Malta',
    countryCode: 'MLT',
    networks: ['GO', 'Vodafone'],
    cities: [
      'Attard',
      'Balzan',
      'Birgu',
      'Birkirkara',
      'Birżebbuġa',
      'Cospicua',
      'Dingli',
      'Fgura',
      'Floriana',
      'Fontana',
      'Gudja',
      'Gżira',
      'Għajnsielem',
      'Għarb',
      'Għargħur',
      'Għasri',
      'Għaxaq',
      'Hamrun',
      'Iklin',
      'Isla',
      'Kalkara',
      'Kerċem',
      'Kirkop',
      'Lija',
      'Luqa',
      'Marsa',
      'Marsaskala',
      'Marsaxlokk',
      'Mdina',
      'Mellieħa',
      'Mġarr',
      'Mosta',
      'Mqabba',
      'Msida',
      'Mtarfa',
      'Munxar',
      'Nadur',
      'Naxxar',
      'Paola',
      'Pembroke',
      'Pietà',
      'Qala',
      'Qormi',
      'Qrendi',
      'Rabat',
      'Safi',
      'San Ġiljan',
      'San Ġwann',
      'San Lawrenz',
      'Sannat',
      'Santa Luċija',
      'Santa Venera',
      'Senglea',
      'Siġġiewi',
      'Sliema',
      "St. Julian's",
      "St. Paul's Bay",
      'Swieqi',
      "Ta' Xbiex",
      'Tarxien',
      'Valletta',
      'Victoria',
      'Vittoriosa',
      'Xagħra',
      'Xewkija',
      'Xgħajra',
      'Żabbar',
      'Żebbuġ',
      'Żejtun',
      'Żurrieq'
    ],
    countryFlag: 'https://flagcdn.com/mt.svg'
  },
  {
    countryName: 'Myanmar',
    countryCode: 'MMR',
    networks: ['MPT', 'Mytel', 'Telenor Myanmar'],
    cities: [
      'Yangon',
      'Mandalay',
      'Naypyidaw',
      'Bago',
      'Pathein',
      'Mawlamyine',
      'Taunggyi',
      'Myitkyina',
      'Pyin Oo Lwin',
      'Hpa-An',
      'Meiktila',
      'Dawei',
      'Sittwe',
      'Lashio',
      'Pakokku',
      'Myeik',
      'Kyaukpyu',
      'Kyaikto',
      'Kyaing Tong',
      'Magway'
    ],
    countryFlag: 'https://flagcdn.com/mm.svg'
  },
  {
    countryName: 'Netherlands',
    countryCode: 'NLD',
    networks: ['KPN', 'Vodafone'],
    cities: [
      'Amsterdam',
      'Rotterdam',
      'The Hague',
      'Utrecht',
      'Eindhoven',
      'Tilburg',
      'Groningen',
      'Almere',
      'Breda',
      'Nijmegen',
      'Enschede',
      'Haarlem',
      'Arnhem',
      'Zaanstad',
      'Amersfoort',
      'Apeldoorn',
      'Hoofddorp',
      'Maastricht',
      'Leiden',
      'Dordrecht',
      'Zwolle',
      'Deventer',
      'Sittard-Geleen',
      'Helmond',
      'Heerlen',
      'Roosendaal',
      'Purmerend',
      'Oss',
      'Schiedam',
      'Lelystad',
      'Alphen aan den Rijn',
      'Gouda',
      'Hoorn',
      'Hengelo',
      'Leeuwarden',
      'Spijkenisse',
      'Vlaardingen',
      'Assen',
      'Bergen op Zoom',
      'Capelle aan den IJssel',
      'Veenendaal',
      'Katwijk',
      'Zeist'
    ],
    countryFlag: 'https://flagcdn.com/nl.svg'
  },
  {
    countryName: 'New Zealand',
    countryCode: 'NZL',
    networks: ['Spark', '2degrees'],
    cities: [
      'Auckland',
      'Wellington',
      'Christchurch',
      'Hamilton',
      'Tauranga',
      'Napier',
      'Dunedin',
      'Palmerston North',
      'Nelson',
      'Rotorua',
      'Whangarei',
      'New Plymouth',
      'Invercargill',
      'Queenstown',
      'Gisborne'
    ],
    countryFlag: 'https://flagcdn.com/nz.svg'
  },
  {
    countryName: 'Norway',
    countryCode: 'NOR',
    networks: ['Telenor', 'Telia'],
    cities: [
      'Oslo',
      'Bergen',
      'Trondheim',
      'Stavanger',
      'Drammen',
      'Fredrikstad',
      'Porsgrunn',
      'Skien',
      'Kristiansand',
      'Tromsø',
      'Ålesund',
      'Moss',
      'Sandefjord',
      'Haugesund',
      'Molde',
      'Hamar'
    ],
    countryFlag: 'https://flagcdn.com/no.svg'
  },
  {
    countryName: 'Pakistan',
    countryCode: 'PAK',
    networks: ['Telenor'],
    cities: [
      'Islamabad',
      'Karachi',
      'Lahore',
      'Rawalpindi',
      'Faisalabad',
      'Multan',
      'Gujranwala',
      'Peshawar',
      'Quetta',
      'Hyderabad',
      'Sialkot',
      'Abbottabad',
      'Bahawalpur',
      'Sargodha',
      'Sukkur',
      'Mardan'
    ],
    countryFlag: 'https://flagcdn.com/pk.svg'
  },
  {
    countryName: 'Philippines',
    countryCode: 'PHL',
    networks: ['Globe'],
    cities: [
      'Manila',
      'Quezon City',
      'Cebu City',
      'Davao City',
      'Makati',
      'Taguig',
      'Pasig',
      'Mandaluyong',
      'Angeles City',
      'Bacolod',
      'Baguio',
      'Cagayan de Oro',
      'Iloilo City',
      'Naga City',
      'Zamboanga City',
      'Tacloban'
    ],
    countryFlag: 'https://flagcdn.com/ph.svg'
  },
  {
    countryName: 'Portugal',
    countryCode: 'PRT',
    networks: ['NOS', 'Vodafone', 'MEO'],
    cities: [
      'Lisbon',
      'Porto',
      'Braga',
      'Funchal',
      'Coimbra',
      'Aveiro',
      'Guimarães',
      'Setúbal',
      'Faro',
      'Évora',
      'Viana do Castelo',
      'Vila Real',
      'Covilhã',
      'Castelo Branco',
      'Beja',
      'Viseu'
    ],
    countryFlag: 'https://flagcdn.com/pt.svg'
  },
  {
    countryName: 'Romania',
    countryCode: 'ROU',
    networks: ['Digi.Mobil', 'Telekom', 'Orange', 'Vodafone'],
    cities: [
      'Bucharest',
      'Cluj-Napoca',
      'Timisoara',
      'Iasi',
      'Constanta',
      'Craiova',
      'Brasov',
      'Galati',
      'Ploiesti',
      'Oradea',
      'Bacau',
      'Arad',
      'Pitesti',
      'Sibiu',
      'Targu Mures',
      'Baia Mare'
    ],
    countryFlag: 'https://flagcdn.com/ro.svg'
  },
  {
    countryName: 'Slovenia',
    countryCode: 'SVN',
    networks: ['Telemach', 'A1', 'Mobitel'],
    cities: [
      'Ljubljana',
      'Maribor',
      'Celje',
      'Kranj',
      'Velenje',
      'Koper',
      'Novo Mesto',
      'Ptuj',
      'Trbovlje',
      'Kamnik',
      'Jesenice',
      'Murska Sobota',
      'Nova Gorica',
      'Škofja Loka',
      'Domžale',
      'Izola',
      'Postojna',
      'Slovenj Gradec',
      'Krško',
      'Lucija'
    ],

    countryFlag: 'https://flagcdn.com/si.svg'
  },
  {
    countryName: 'South Korea',
    countryCode: 'KOR',
    networks: ['KT', 'SK Telink'],
    cities: [
      'Seoul',
      'Busan',
      'Incheon',
      'Daegu',
      'Daejeon',
      'Gwangju',
      'Suwon',
      'Ulsan',
      'Changwon',
      'Sejong',
      'Jeonju',
      'Cheonan',
      'Ansan',
      'Namyangju',
      'Pohang',
      'Jeju',
      'Gimhae',
      'Sacheon',
      'Sokcho',
      'Mokpo',
      'Andong',
      'Gyeongju',
      'Muan',
      'Yeongju',
      'Yeongcheon',
      'Gunsan',
      'Suncheon',
      'Gumi',
      'Wonju',
      'Goyang',
      'Iksan',
      'Yangsan',
      'Jecheon',
      'Chungju',
      'Gwangmyeong',
      'Hongseong',
      'Gimje',
      'Kimje',
      'Jinju',
      'Hwaseong',
      'Naju',
      'Pocheon',
      'Gwangyang',
      'Asan',
      'Hamyang',
      'Miryang',
      'Gwangju',
      'Uijeongbu',
      'Gwangsan-gu',
      'Hanam',
      'Yeosu',
      'Gangneung',
      'Uiwang',
      'Seosan',
      'Guri',
      'Gimpo',
      'Sangju',
      'Munsan',
      'Nonsan',
      'Cheongju',
      'Icheon',
      'Osan',
      'Jungnang-gu',
      'Yangju',
      'Seogwipo',
      'Yeongam',
      'Paju',
      'Yecheon',
      'Boryeong',
      'Hwado-myeon',
      'Hwaseong-si',
      'Goseong',
      'Okcheon',
      'Bucheon',
      'Hwacheon',
      'Yongin',
      'Eumseong',
      'Gapyeong',
      'Hwawon',
      'Hwaseong-si',
      'Gangjin',
      'Sangju',
      'Gunsan-si',
      'Chuncheon',
      'Sokcho-si',
      'Sunchang',
      'Seocheon',
      'Cheongdo',
      'Seocheon-gun',
      'Naju-si',
      'Damyang',
      'Gimcheon',
      'Uiryeong',
      'Yeongdeok',
      'Goryeong',
      'Wanju',
      'Jincheon',
      'Jeungpyeong',
      'Uljin',
      'Taebaek',
      'Ganghwa-gun',
      'Hampyeong',
      'Jinjeop-eup',
      'Gangdong-gu',
      'Changnyeong',
      'Sancheong',
      'Mungyeong',
      'Yangyang',
      'Pyeongchang',
      'Jangheung',
      'Yeonggwang',
      'Namhae-gun',
      'Punggi',
      'Gangseo-gu',
      'Seo-gu',
      'Oksan-myeon',
      'Yeoju',
      'Yeocheon',
      'Hapcheon'
    ],
    countryFlag: 'https://flagcdn.com/kr.svg'
  },
  {
    countryName: 'Spain',
    countryCode: 'ESP',
    networks: ['Amena', 'Vodafone', 'Movistar', 'Yoigo'],
    cities: [
      'Madrid',
      'Barcelona',
      'Valencia',
      'Seville',
      'Zaragoza',
      'Malaga',
      'Murcia',
      'Palma',
      'Las Palmas de Gran Canaria',
      'Bilbao',
      'Alicante',
      'Cordoba',
      'Valladolid',
      'Vigo',
      'Gijon',
      "L'Hospitalet de Llobregat",
      'La Coruna',
      'Granada',
      'Vitoria-Gasteiz',
      'Elche'
    ],
    countryFlag: 'https://flagcdn.com/es.svg'
  },
  {
    countryName: 'Sweden',
    countryCode: 'SWE',
    networks: ['Telenor', '3', 'Tele2'],
    cities: [
      'Stockholm',
      'Gothenburg',
      'Malmö',
      'Uppsala',
      'Västerås',
      'Örebro',
      'Linköping',
      'Helsingborg',
      'Jönköping',
      'Norrköping',
      'Lund',
      'Umeå',
      'Gävle',
      'Södertälje',
      'Växjö',
      'Eskilstuna',
      'Karlstad',
      'Täby',
      'Sundsvall',
      'Halmstad',
      'Luleå',
      'Trollhättan',
      'Borås',
      'Falun',
      'Kalmar',
      'Kristianstad',
      'Skövde',
      'Karlskrona',
      'Örnsköldsvik',
      'Visby'
    ],
    countryFlag: 'https://flagcdn.com/se.svg'
  },
  {
    countryName: 'Switzerland',
    countryCode: 'CHE',
    networks: ['Salt', 'Sunrise'],
    cities: [
      'Zurich',
      'Geneva',
      'Basel',
      'Lausanne',
      'Bern',
      'Winterthur',
      'Lucerne',
      'St. Gallen',
      'Lugano',
      'Biel/Bienne',
      'Thun',
      'Köniz',
      'La Chaux-de-Fonds',
      'Fribourg',
      'Schaffhausen',
      'Chur',
      'Vernier',
      'Uster',
      'Sion',
      'Emmen',
      'Neuchâtel',
      'Zug',
      'Yverdon-les-Bains',
      'Dübendorf',
      'Dubendorf',
      'Montreux',
      'Bülach',
      'Baden',
      'Carouge',
      'Wetzikon',
      'Olten',
      'Onex',
      'Thalwil',
      'Zollikon',
      'Rüti',
      'Münsingen',
      'Plan-les-Ouates',
      'Bussigny',
      'Renens',
      'Birsfelden',
      'Val-de-Travers',
      'Le Grand-Saconnex',
      'Gland',
      'Allschwil',
      'Pully',
      'Oberwil',
      'Brugg',
      'Brig-Glis',
      'Steffisburg',
      'Affoltern am Albis',
      'Meyrin',
      'Weinfelden',
      'Morges',
      'Rorschach',
      'Pratteln',
      'Arth',
      'Burgdorf',
      'Spreitenbach',
      'Regensdorf',
      'Langenthal',
      'Gossau',
      'Romanshorn',
      'Muri bei Bern',
      'Küsnacht',
      'Rheinfelden',
      'Ebikon',
      'Amriswil',
      'Möhlin',
      'Pfäffikon',
      'Stäfa',
      'Sierre',
      'Spreitenbach AG',
      'Sierre VS',
      'Le Mont-sur-Lausanne',
      'Biberist',
      'Cadenazzo',
      'Lyss',
      'Steinhausen',
      'Kriens',
      'Worb',
      'Binningen',
      'Wil SG',
      'Steffisburg BE',
      'Belp',
      'Worb BE',
      'Arbon',
      'Zollikofen',
      'Ostermundigen',
      'Rümlang',
      'Walenstadt',
      'Prilly',
      'Zuchwil',
      'Oberwil BL',
      'Visp',
      'Rüti ZH',
      'Reinach BL',
      'Zuchwil SO',
      'Bremgarten AG',
      'Frenkendorf',
      'Stans',
      'Bex',
      'Zofingen',
      'Tavannes',
      'Oberengstringen',
      'Möhlin AG',
      'Aarberg',
      'Bad Zurzach',
      'Niederlenz',
      'Uzwil',
      'Thalwil ZH',
      'Burgistein',
      'Wohlen AG',
      'Altstätten',
      'Schattdorf',
      'Goldach',
      'Sarnen',
      'Illnau',
      'Kehrsatz',
      'Hochdorf'
    ],
    countryFlag: 'https://flagcdn.com/ch.svg'
  },
  {
    countryName: 'Taiwan',
    countryCode: 'TWN',
    networks: ['Chunghwa', 'Taiwan Mobile'],
    cities: [
      'Taipei',
      'Kaohsiung',
      'Taichung',
      'Tainan',
      'Banqiao',
      'Hsinchu',
      'Taoyuan',
      'Keelung',
      'Hualien City',
      'Chiayi City',
      'Yilan City',
      'Nantou City',
      'Pingtung City',
      'Miaoli City'
    ],
    countryFlag: 'https://flagcdn.com/tw.svg'
  },
  {
    countryName: 'Thailand',
    countryCode: 'THA',
    networks: ['CAT Telecom', 'TrueMove H'],
    cities: [
      'Bangkok',
      'Chiang Mai',
      'Phuket',
      'Pattaya',
      'Krabi',
      'Hua Hin',
      'Samui',
      'Chiang Rai',
      'Nakhon Ratchasima',
      'Ayutthaya',
      'Khon Kaen',
      'Surat Thani',
      'Nakhon Si Thammarat',
      'Udon Thani',
      'Rayong'
    ],
    countryFlag: 'https://flagcdn.com/th.svg'
  },
  {
    countryName: 'Turkey',
    countryCode: 'TUR',
    networks: ['Turk Telekom', 'Vodafone'],
    cities: [
      'Istanbul',
      'Ankara',
      'Izmir',
      'Bursa',
      'Adana',
      'Gaziantep',
      'Antalya',
      'Konya',
      'Mersin',
      'Diyarbakir',
      'Kayseri',
      'Eskisehir',
      'Sanliurfa',
      'Samsun',
      'Denizli',
      'Batman',
      'Van',
      'Erzurum',
      'Malatya',
      'Trabzon',
      'Sivas',
      'Balikesir',
      'Kahramanmaras',
      'Tekirdag',
      'Aydin',
      'Usak',
      'Corum',
      'Manisa',
      'Aydin',
      'Zonguldak',
      'Kutahya',
      'Afyonkarahisar',
      'Bolu',
      'Karaman',
      'Bingol',
      'Elazig',
      'Kirikkale',
      'Nigde',
      'Ordu',
      'Rize',
      'Yozgat'
    ],
    countryFlag: 'https://flagcdn.com/tr.svg'
  },
  {
    countryName: 'United Kingdom',
    countryCode: 'UK',
    networks: ['O2', 'Three', 'Vodafone', 'EE'],
    cities: [
      'London',
      'Manchester',
      'Birmingham',
      'Liverpool',
      'Glasgow',
      'Edinburgh',
      'Bristol',
      'Belfast',
      'Leeds',
      'Sheffield',
      'Newcastle upon Tyne',
      'Cardiff',
      'Dublin',
      'Cambridge',
      'Oxford',
      'Brighton',
      'Nottingham',
      'Leicester',
      'Southampton',
      'Portsmouth',
      'Aberdeen',
      'Dundee',
      'York',
      'Reading',
      'Milton Keynes',
      'Coventry',
      'Stoke-on-Trent',
      'Plymouth',
      'Swansea'
    ],
    countryFlag: 'https://flagcdn.com/gb.svg'
  },
  {
    countryName: 'United States of America',
    countryCode: 'USA',
    networks: ['Ting', 'AT&T'],
    cities: [
      'New York City',
      'Los Angeles',
      'Chicago',
      'Houston',
      'Philadelphia',
      'Phoenix',
      'San Antonio',
      'San Diego',
      'Dallas',
      'San Jose',
      'Austin',
      'Jacksonville',
      'Fort Worth',
      'Columbus',
      'San Francisco',
      'Charlotte',
      'Indianapolis',
      'Seattle',
      'Denver',
      'Washington, D.C.',
      'Boston',
      'Nashville',
      'El Paso',
      'Detroit',
      'Memphis',
      'Portland',
      'Oklahoma City',
      'Las Vegas',
      'Louisville',
      'Baltimore',
      'Milwaukee',
      'Albuquerque',
      'Tucson',
      'Fresno',
      'Sacramento',
      'Mesa',
      'Atlanta',
      'Kansas City',
      'Colorado Springs',
      'Miami',
      'Raleigh',
      'Omaha',
      'Long Beach',
      'Virginia Beach',
      'Oakland',
      'Minneapolis',
      'Tulsa',
      'Wichita',
      'New Orleans',
      'Arlington',
      'Tampa',
      'Aurora',
      'Santa Ana',
      'St. Louis',
      'Pittsburgh',
      'Corpus Christi',
      'Riverside',
      'Cincinnati',
      'Lexington',
      'Anchorage',
      'Stockton',
      'Toledo',
      'Saint Paul',
      'Newark',
      'Greensboro',
      'Buffalo',
      'Plano',
      'Lincoln',
      'Henderson',
      'Fort Wayne',
      'Jersey City',
      'St. Petersburg',
      'Chula Vista',
      'Norfolk',
      'Orlando',
      'Chandler',
      'Laredo',
      'Madison',
      'Winston-Salem',
      'Lubbock',
      'Baton Rouge',
      'Durham',
      'Garland',
      'Glendale',
      'Reno',
      'Hialeah',
      'Chesapeake',
      'Scottsdale',
      'North Las Vegas',
      'Irving',
      'Fremont',
      'Irvine',
      'Birmingham',
      'Rochester',
      'San Bernardino',
      'Spokane',
      'Gilbert',
      'Arlington',
      'Montgomery',
      'Boise',
      'Richmond',
      'Des Moines',
      'Modesto',
      'Fayetteville',
      'Shreveport',
      'Akron',
      'Tacoma',
      'Aurora',
      'Oxnard',
      'Fontana',
      'Yonkers',
      'Augusta',
      'Mobile',
      'Little Rock',
      'Moreno Valley',
      'Glendale',
      'Amarillo',
      'Huntington Beach',
      'Columbus',
      'Grand Rapids',
      'Salt Lake City',
      'Tallahassee',
      'Worcester',
      'Newport News',
      'Huntsville',
      'Knoxville',
      'Providence',
      'Santa Clarita',
      'Grand Prairie',
      'Brownsville',
      'Jackson',
      'Overland Park',
      'Garden Grove',
      'Santa Rosa',
      'Chattanooga',
      'Oceanside',
      'Fort Lauderdale',
      'Rancho Cucamonga',
      'Port St. Lucie',
      'Tempe',
      'Ontario',
      'Vancouver',
      'Cape Coral',
      'Sioux Falls',
      'Springfield',
      'Peoria',
      'Pembroke Pines',
      'Elk Grove',
      'Salem',
      'Lancaster',
      'Corona',
      'Eugene',
      'Palmdale',
      'Salinas',
      'Springfield',
      'Pasadena',
      'Fort Collins',
      'Hayward',
      'Pomona',
      'Cary',
      'Alexandria',
      'Escondido',
      'Sunnyvale',
      'Lakewood',
      'Kansas City',
      'Rockford',
      'Torrence',
      'Hollywood',
      'Joliet',
      'Bridgeport',
      'Clarksville'
    ],
    countryFlag: 'https://flagcdn.com/us.svg'
  },
  {
    countryName: 'Vatican City',
    countryCode: 'VAT',
    networks: ['WINDTRE', 'Vodafone', 'Wind'],
    cities: [],
    countryFlag: 'https://flagcdn.com/va.svg'
  },
  {
    countryName: 'Vietnam',
    countryCode: 'VNM',
    networks: ['MobiFone'],
    cities: [
      'Ho Chi Minh City',
      'Hanoi',
      'Da Nang',
      'Hoi An',
      'Nha Trang',
      'Can Tho',
      'Hai Phong',
      'Hue',
      'Vinh',
      'Qui Nhon',
      'Ha Long',
      'Vung Tau',
      'Bien Hoa',
      'Phan Thiet',
      'Rach Gia',
      'Long Xuyen',
      'Thanh Hoa',
      'Buon Ma Thuot',
      'Nam Dinh',
      'Cam Ranh',
      'Quang Ngai',
      'Thai Nguyen',
      'Rạch Giá',
      'Cao Lanh',
      'Ben Tre',
      'My Tho',
      'Sa Dec',
      'Tra Vinh',
      'Soc Trang',
      'Dong Hoi',
      'Tam Ky',
      'Lao Cai',
      'Tuy Hoa',
      'Can Gio',
      'Son La',
      'Bac Ninh',
      'Thai Binh',
      'Yen Bai',
      'Lang Son',
      'Phu Ly',
      'Pleiku',
      'Thu Dau Mot',
      'Tay Ninh',
      'Ca Mau',
      'Vinh Long',
      'Ninh Binh',
      'Bắc Giang',
      'Ha Tinh',
      'Phu Quoc',
      'Mong Cai',
      'Vi Thanh',
      'Yên Bái',
      'Long Khanh',
      'Hưng Yên',
      'Quảng Trị'
    ],
    countryFlag: 'https://flagcdn.com/vn.svg'
  }
]
export default preferredNetworks
